import api from "./Api";

export const registraControleAcesso = (data) =>
  api.post("api/controleAcesso", data);
